import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock } from 'react-icons/fa';
import SectionTitle from '../../components/common/SectionTitle';
import { fadeInUp, staggerContainer, enhancedViewport } from '../../utils/animation';
import './ContactInfo.scss';

const ContactInfo = () => {
  const { t } = useTranslation('contact');
  const icons = [<FaMapMarkerAlt />, <FaPhone />, <FaEnvelope />, <FaClock />];
  const keys = ['address', 'phone', 'email', 'schedule'];
  
  // OPTIMIZAT: Eliminat useAnimation() și useEffect() overhead - folosim whileInView direct
  return (
    <section className="contact-info">
      <div className="container">
        <SectionTitle>{t('info.title')}</SectionTitle>
        
        <motion.div
          className="contact-info__grid"
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
        >
          {keys.map((key, index) => {
            const item = t(`info.${key}`, { returnObjects: true });
            return (
              <motion.div 
                className="contact-info__card" 
                key={key}
                variants={fadeInUp}
              >
                <div className="contact-info__icon">
                  {icons[index]}
                </div>
                <h3 className="contact-info__card-title">{item.title}</h3>
                <p className="contact-info__details">{item.value}</p>
              </motion.div>
            );
          })}
        </motion.div>
        
        <motion.div
          className="contact-info__map"
          initial="hidden"
          whileInView="visible"
          viewport={enhancedViewport}
          variants={fadeInUp}
        >
          <iframe 
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11474.873826384847!2d24.8639!3d44.9892!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40b28f5f3c5c9d65%3A0x3064a7b8f6b3c3a0!2zTMSDcHXImWFuaSwgUm9tw6JuaWE!5e0!3m2!1sro!2sro!4v1634567890123!5m2!1sro!2sro" 
            allowFullScreen="" 
            loading="lazy" 
            referrerPolicy="no-referrer-when-downgrade"
            title="Locația companiei - Lăpușani, Coșești, Argeș"
          ></iframe>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactInfo;
